/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { flowRight } from 'lodash'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import withReservation, { ReservationProps } from '../../providers/Reservation/withReservation'
import { RouterItem } from '../../config/router.config'
import withWizardProps, { WizardProps } from '../../wrappers/withWizardParams'
import {
  getGrantCompanies,
  getInscriptionConfiguration,
  getReservation,
} from '../../requests/inscription'
import DetailResolver from '../../components/Resolvers/DetailResolver'
import LoaderWrapper from '../../components/Utils/LoaderWrapper'
import Row from '../../components/Form/Row'
import Col from '../../components/Form/Col'
import { Trans } from '@lingui/macro'
import styled from 'styled-components'
import 'moment/locale/es'
import { fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'
import appStore from '../../static/images/storeBadges/appStore.svg'
import googlePlay from '../../static/images/storeBadges/googlePlay.png'
import Section from '../../components/Section/Section'
import { openAppURL } from '../../helpers/general'
import withURLParams, { URLParamsComponentProps } from '../../providers/URLParams/withURLParams'
import Button from '../../components/Utils/Button'

interface Props extends ComponentProps, RouteComponentProps, WizardProps, ReservationProps, URLParamsComponentProps {
  step: RouterItem;
  congress?: any;
}

interface State {
  values: any,
  isValid: boolean,
  isLoading: boolean,
}

class Payment extends React.Component<Props, State> {
  state: State = {
    values: {},
    isValid: true,
    isLoading: false,
  }

  componentWillMount () {
    const { reservation, params } = this.props

    if (params && params.returnTo && params.skipSuccess) {
      openAppURL(params.returnTo.replace('%3Aemail', reservation.data.Email))
    }
  }

  render () {
    const { reservation } = this.props

    return (
      <DetailResolver
        requestFunction={async () => {
          try {
            const reservationData = await getReservation({ id: reservation.data.UUID })
            const grantCompanies = await getGrantCompanies()

            return {
              reservation: reservationData.Data,
              grantCompanies: grantCompanies.Data
            }
          } catch (e) {
            return { reservation: null, configuration: null, grantCompanies: null }
          }
        }}
        render={this.renderContent}
      />
    )
  }

  renderContent = (data: any) => {
    const { isLoading } = this.state
    const { congress, reservation } = this.props
    const isConfirmed = reservation.data.IsConfirmed
    console.log("reservation", reservation)
    console.log("data", reservation.data)
    return (
      <LoaderWrapper isLoading={isLoading}>
        {isConfirmed ? (
          <Section>
            <Row gutter={32} m={0} align="top">
              {/* <Col md={7}>
                <BannerContainer>
                  <Banner src={congress.ScreenshotURL}/>
                </BannerContainer>
              </Col> */}

              <Col md={24}>
                <h1><Trans>¡Inscripción Exitosa!, Recibirá un correo de confirmación</Trans></h1>
                <h3><strong>¿No le ha llegado el correo?</strong></h3>
                <p><Trans>Si no le llega nuestro correo en los próximos minutos, puede haber pasado una de las siguientes cosas:</Trans></p>
                <ul>
                  <li><Trans>El correo está en su carpeta de spam. (Las cosas se pierden ahí a veces.)</Trans></li>
                  <li><Trans>El correo ingresado tiene errores de tipeo. (A cualquiera le puede pasar.)</Trans></li>
                  <li><Trans>Accidentalmente ingresó otro correo. (Usualmente uno personal o de trabajo en vez de el que usted quería ingresar.)</Trans></li>
                  <li><Trans>No podemos envíar el correo a su dirección. (Usualmente por causa de firewalls o filtros de su corporación.)</Trans></li>
                </ul>
                {/* <h1><Trans>¡Próximamente podrá descargar la app del evento!</Trans></h1> */}
                <h3><Trans>Con la aplicación podrá:</Trans></h3>
                <ul>
                  {/* <li><Trans>Acreditarse rápidamente el día del evento, con tu código QR.</Trans></li> */}
                  <li><Trans>Revisar el programa y sus respectivos detalles.</Trans></li>
                  <li><Trans>Ver los expositores que participarán y sus detalles.</Trans></li>
                  <li><Trans>Ver las empresas que participarán de la Expo</Trans></li>
                  <li><Trans>Revisar las noticias del evento.</Trans></li>
                  <li><Trans>Recibir notificaciones sobre novedades y avisos importantes.</Trans></li>
                  <li><Trans>Entregar feedback el día del evento.</Trans></li>
                  <li><Trans>Contactarse con la organización.</Trans></li>
                </ul>

                {congress.AppStoreURL || congress.GooglePlayURL ?
                  <StoreBadgesText><Trans>Descarguela ahora</Trans></StoreBadgesText> : null
                }

                <StoreBadges>
                  {congress.AppStoreURL ?
                    <a href={congress.AppStoreURL} target="_blank">
                      <AppStoreBadge src={appStore} alt="Download on the App Store"/>
                    </a> : null}

                  {congress.GooglePlayURL ?
                    <a href={congress.GooglePlayURL} target="_blank">
                      <StoreBadge src={googlePlay} alt="Get it on Google Play"/>
                    </a> : null}

                </StoreBadges>
              </Col>
            </Row>

            {/* <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <Button color={congress.PrimaryColor} onClick={this.handleFinish}>
                <Trans>¡Finalizar registro!</Trans>
              </Button>
            </div> */}
          </Section>
        ) : (
          <Section>
            <Row gutter={32} m={0} align="top">
              {/*<Col md={7}>*/}
              {/*  <BannerContainer>*/}
              {/*    <Banner src={congress.ScreenshotURL}/>*/}
              {/*  </BannerContainer>*/}
              {/*</Col>*/}

              <Col md={24}>
                <div style={{ marginBottom: 32, marginTop: 32 }}>
                  <h1>SI YA PAGASTE EL CONGRESO O ERES BECADO</h1>
                  <ul>
                    <li>Debes esperar la confirmación vía correo electrónico en un plazo de 48 horas.</li>
                    <li>Para dudas escribir a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a> o <a href="mailto:paola@congresoveterinario.cl">paola@congresoveterinario.cl</a>.</li>
                  </ul>
                </div>

                <h1>SI QUIERES COMPRAR UN CUPO</h1>
                  <ul>
                    <li>Debes ponerte en contacto con Malú Carvajal: <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
                  </ul>
                {congress.Slug === "veterinario-virtual-2022" ? this.renderVirtual() : null }
                {congress.Slug === "veterinario-colchagua-2022" ? (
                  <div>
                    {this.renderNonPaymentInfo()}
                    <div style={{ marginBottom: 32, marginTop: 32 }}>
                      <h1>¡INSCRÍBETE EN LOS TALLERES EXTRAORDINARIOS!</h1>
                      <h3>Taller 1: MBA. Ariel Baños. Debates, análisis de casos sobre precios. Valor: CLP$50.000 - USD$50.</h3>
                      <h3>Taller 2: Dr. Luis Tello. Mis aciertos y errores como médico veterinario. Valor: CLP$50.000 - USD$50</h3>
                      <h3>Detalles e inscripciones: <a target='blanc' href="https://forms.gle/Kr8z9eVZEYRf1qok6">clic aquí</a></h3>
                    </div>
                  </div>) : null }

                {congress.ScreenshotURL ?
                  <StoreBadges>
                    <a href="https://apps.apple.com/us/app/trazo-events/id1476474475" target="_blank">
                      <AppStoreBadge src={appStore} alt="Download on the App Store"/>
                    </a>

                    <a href="https://play.google.com/store/apps/details?id=com.trazolabs.summit.trazoevents" target="_blank">
                      <StoreBadge src={googlePlay} alt="Get it on Google Play"/>
                    </a>
                  </StoreBadges> : null
                }

              </Col>
            </Row>

            {/*<Row>*/}
            {/*  <Col>*/}
            {/*    <SubHeading>Aplicación liviana. Su descarga no tomará más de 1 minuto.</SubHeading>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
          </Section>
        )}


        <Legal>Google Play and the Google Play logo are trademarks of Google LLC.</Legal>
        <Legal>Apple, the Apple logo, iPhone, and iPad are trademarks of Apple Inc., registered in the U.S. and other
          countries and regions. App Store is a service mark of Apple Inc.</Legal>
      </LoaderWrapper>
    )
  }

  renderVirtual = () => {
    const { congress } = this.props

    return (
      <section>
        <div style={{ marginBottom: 16 }}>
          <h3>Si estás en Chile: Debes pagar $82.000 en este botón:</h3>
          <Button onClick={() => openInNewTab('https://congresoveterinario.cl/payment/chilean')} color={congress.PrimaryColor}>Pagar (Chile)</Button>
        </div>

        <ul>
          <li>Debes enviar el comprobante del pago a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
          <li>Una vez enviado el comprobante, debes esperar la confirmación vía correo electrónico en un plazo de 48 horas.</li>
          <li>Para dudas escribir a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
        </ul>

        <div style={{ marginBottom: 16, marginTop: 32 }}>
          <h3>Si NO estás en Chile: Debes pagar USD$100 en este botón:</h3>
          <Button onClick={() => openInNewTab('https://congresoveterinario.cl/payment/foreigner')} color={congress.PrimaryColor}>Pagar (Resto del Mundo)</Button>
        </div>

        <ul>
          <li>Debes enviar el comprobante del pago a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
          <li>Una vez enviado el comprobante, debes esperar la confirmación vía correo electrónico en un plazo de 48 horas.</li>
          <li>Para dudas escribir a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
      </ul>
    </section>
    )
  }

  renderNonPaymentInfo = () => {
    return (
      <section>
        <div style={{ marginBottom: 16 }}>
          <h3>Debes escribir a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a> para coordinar.</h3>
        </div>
      </section>
    )
  }

  renderPaymentInfo = () => {
    const { congress } = this.props

    return (
      <section>
        <div style={{ marginBottom: 16 }}>
          <h3>Si estás en Chile: Debes pagar uno de los siguientes valores en el siguiente botón:</h3>
          <h3>Habitación ejecutiva Single: $656.000</h3>
          <ul>
            <li>Habitación single para una persona.</li>
            <li>Plan de alimentación con bebidas y fiestas todo incluido.</li>
            <li>Acceso a todas las charlas y actividades del congreso.</li>
          </ul>

          <h3>Habitación Compartida: $492.000 (Por persona)</h3>
          <ul>
            <li>Habitación doble para dos personas.</li>
            <li>Plan de alimentación con bebidas y fiestas todo incluido.</li>
            <li>Acceso a todas las charlas.</li>
          </ul>

          <h3>Asistencia sin Habitación: $246.000</h3>
          <ul>
            <li>Alimentación y bebidas incluidas, no incluye desayuno.</li>
            <li>Acceso a todas las charlas y actividades del congreso.</li>
          </ul>
          <Button onClick={() => openInNewTab('https://congresoveterinario.cl/payment/chilean')} color={congress.PrimaryColor}>Pagar (Chile)</Button>
        </div>

        <ul>
          <li>Debes enviar el comprobante del pago a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
          <li>Una vez enviado el comprobante, debes esperar la confirmación vía correo electrónico en un plazo de 48 horas.</li>
          <li>Para dudas escribir a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
        </ul>

        <div style={{ marginBottom: 16, marginTop: 32 }}>
          <h3>Si NO estás en Chile: Debes pagar uno de los siguientes valores en el siguiente botón:</h3>
          <h3>Habitación ejecutiva Single: USD$800</h3>
          <ul>
            <li>Habitación single para una persona.</li>
            <li>Plan de alimentación con bebidas y fiestas todo incluido.</li>
            <li>Acceso a todas las charlas y actividades del congreso.</li>
          </ul>

          <h3>Habitación Compartida: USD$600 (Por persona)</h3>
          <ul>
            <li>Habitación doble para dos personas.</li>
            <li>Plan de alimentación con bebidas y fiestas todo incluido.</li>
            <li>Acceso a todas las charlas.</li>
          </ul>

          <h3>Asistencia sin Habitación: USD$300</h3>
          <ul>
            <li>Alimentación y bebidas incluidas, no incluye desayuno.</li>
            <li>Acceso a todas las charlas y actividades del congreso.</li>
          </ul>
          <Button onClick={() => openInNewTab('https://congresoveterinario.cl/payment/foreigner')} color={congress.PrimaryColor}>Pagar (Resto del Mundo)</Button>
        </div>

        <ul>
          <li>Debes enviar el comprobante del pago a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
          <li>Una vez enviado el comprobante, debes esperar la confirmación vía correo electrónico en un plazo de 48 horas.</li>
          <li>Para dudas escribir a <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></li>
      </ul>
    </section>
    )
  }
}

const Legal = styled.div`
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: #cccccc;
`

const StoreBadgesText = styled.h3`
  margin-top: 24px;
`

const StoreBadges = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`

const StoreBadge = styled.img`
  width: 150px;
`

const AppStoreBadge = styled(StoreBadge)`
  max-height: 40px;
`

const Heading = styled.h1`
  text-align: center;
`

const SubHeading = styled.h3`
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: center;
`

const ErrorWrapper = styled.div<SpaceProps>`
  * {
    display: block;
    text-align: center;
    width: 100%;
  }

  ${space}
`

const BannerContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
`

const Banner = styled.img<SpaceProps & any>`
  width: 100%;
  max-width: 200px;
  border-radius: 5px;

  ${({ hidden }) => hidden && 'display: none;'}

  ${space}
`

export default flowRight([withCongress, withWizardProps, withReservation, withURLParams])(withCongress(Payment))

function openInNewTab(url: string) {
  const win = window.open(url, '_blank')
  if (win) {
    win.focus();
  }
}
